import {
  LIBRARY_RECEIVE,
  LIBRARY_RECEIVE_CATEGORIES,
  LIBRARY_RECEIVE_DOCUMENT_TYPES,
  LIBRARY_FILTER,
  LIBRARY_SELECTED,
} from '../constants';

const DEFAULT_STATE = {
  fileTemplateType: 1,
  query: '',
  category: '',
  documentType: '',
  documents: [],
  photos: [],
  categories: [],
  documentTypes: [],
  selected: [],
  zip: true,
  pageNumber: 1,
};

export const library = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LIBRARY_RECEIVE:
    case LIBRARY_RECEIVE_CATEGORIES:
    case LIBRARY_RECEIVE_DOCUMENT_TYPES:
    case LIBRARY_FILTER:
    case LIBRARY_SELECTED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
